import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`For getting started with the template you have to follow the below procedure. For quick guide you can check below videos for installation.`}</p>
    <h2 {...{
      "id": "installation-video"
    }}>{`Installation Video`}</h2>
    <iframe width="1024" height="600" src="https://www.youtube.com/embed/xoQn4AoemxU" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <h2 {...{
      "id": "prerequisites"
    }}>{`Prerequisites`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`PHP 8.1`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Composer`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Xamp/Wamp/Lamp for any such application for apache, nginx, mysql`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`PHP plugins you must need`}</p>
        <ul parentName="li">
          <li parentName="ul">{`simplexml`}</li>
          <li parentName="ul">{`PHP's dom extension`}</li>
          <li parentName="ul">{`mbstring`}</li>
          <li parentName="ul">{`GD Library`}</li>
        </ul>
      </li>
    </ul>
    <h3 {...{
      "id": "frontend"
    }}>{`Frontend`}</h3>
    <ul>
      <li parentName="ul">{`node(20.0.0 or later, `}<inlineCode parentName="li">{`v20.9.0`}</inlineCode>{` much more appreciable)`}</li>
      <li parentName="ul">{`yarn`}</li>
      <li parentName="ul">{`editor: `}<a parentName="li" {...{
          "href": "https://code.visualstudio.com/"
        }}>{`Visual Studio Code`}</a>{`(recommended)`}</li>
    </ul>
    <h3 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h3>
    <ol>
      <li parentName="ol">{`First download the file from codecanyon.`}</li>
      <li parentName="ol">{`Unzip the downloaded file and folder structure you get`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`pickbazar
|-- api
|-- admin
  |-- rest
  |-- graphql
|-- shop
`}</code></pre>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">
        <p parentName="li">{`From the above folder structure you should notice that our app has three parts `}<inlineCode parentName="p">{`api`}</inlineCode>{` ,`}<inlineCode parentName="p">{`shop`}</inlineCode>{` and `}<inlineCode parentName="p">{`admin`}</inlineCode>{`. So you have to run all the parts separately and sequentially.`}</p>
        <h4 parentName="li" {...{
          "id": "getting-started-with-api"
        }}>{`Getting started with api`}</h4>
        <ul parentName="li">
          <li parentName="ul">{`Make sure you have run XAMPP/mamp/wamp/lamp for mysql and php by following the steps below:`}</li>
        </ul>
        <p parentName="li">{`Click on action button start to make it start.`}</p>
        <p parentName="li"><img alt="click on start" src={require("../../images/xamp-start.png")} /></p>
        <p parentName="li">{`XAMPP has been started.`}</p>
        <p parentName="li"><img alt="XAMPP started" src={require("../../images/xamp.png")} /></p>
        <ul parentName="li">
          <li parentName="ul">{`Go to localhost/phpmyadmin`}</li>
        </ul>
        <p parentName="li"><img alt="localhost" src={require("../../images/localhost.png")} /></p>
        <ul parentName="li">
          <li parentName="ul">{`Click on new to create new database.`}</li>
        </ul>
        <p parentName="li"><img alt="New database" src={require("../../images/new.png")} /></p>
        <ul parentName="li">
          <li parentName="ul">{`Create a database in your mysql and put those info in next step.`}</li>
        </ul>
        <p parentName="li"><img alt="create database" src={require("../../images/DB.png")} /></p>
        <ul parentName="li">
          <li parentName="ul">
            <p parentName="li">{`Inside api folder rename .env.example file to .env and provide necessary credentials. Like database credentials, stripe credentials, s3 credentials(only if you use s3 disk) admin email shop url etc.
Specially check for this `}<inlineCode parentName="p">{`env`}</inlineCode>{` variables`}</p>
            <pre parentName="li"><code parentName="pre" {...{}}>{`DB_HOST=localhost
DB_DATABASE=pickbazar_laravel
DB_USERNAME=root
DB_PASSWORD=
`}</code></pre>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Run `}<inlineCode parentName="p">{`composer install`}</inlineCode>{`using terminal`}</p>
            <p parentName="li"><img alt="composer install" src={require("../../images/composer-install-1.png")} /></p>
            <p parentName="li"><img alt="composer success" src={require("../../images/composer-success.png")} /></p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`run `}<inlineCode parentName="p">{`php artisan key:generate`}</inlineCode></p>
            <p parentName="li"><img alt="app key" src={require("../../images/app-key.png")} /></p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Run `}<inlineCode parentName="p">{`php artisan marvel:install`}</inlineCode>{` and follow necessary steps.`}</p>
            <p parentName="li"><img alt="pickbazar install" src={require("../../images/pickbazar-install.png")} /></p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`For image upload to work properly you need to run `}<inlineCode parentName="p">{`php artisan storage:link`}</inlineCode>{`.`}</p>
          </li>
        </ul>
        <p parentName="li"><img alt="storage link" src={require("../../images/storage-link.png")} /></p>
        <ul parentName="li">
          <li parentName="ul">
            <p parentName="li">{`run `}<inlineCode parentName="p">{`php artisan serve`}</inlineCode></p>
            <p parentName="li"><img alt="server start" src={require("../../images/server-start.png")} /></p>
          </li>
        </ul>
      </li>
    </ol>
    <blockquote>
      <p parentName="blockquote">{`NB: your frontend `}<inlineCode parentName="p">{`NEXT_PUBLIC_GRAPHQL_API_ENDPOINT`}</inlineCode>{` env value will be `}<inlineCode parentName="p">{`localhost:8000/graphql`}</inlineCode></p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`NB: your frontend `}<inlineCode parentName="p">{`NEXT_PUBLIC_REST_API_ENDPOINT`}</inlineCode>{` env value will be `}<inlineCode parentName="p">{`localhost:8000/`}</inlineCode></p>
    </blockquote>
    <h2 {...{
      "id": "getting-started-with-frontend"
    }}>{`Getting Started with Frontend`}</h2>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`After configuring API & running it successfully you can choose the directory where you need to work`}</li>
    </ol>
    <h4 {...{
      "id": "note-only-for-windows-user--if-you-want-to-use-graphql-version"
    }}>{`NOTE: only for windows user ( if you want to use GraphQL version)`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`- Go to your specific project root and find \`.graphql-let.yml\`.
- To find the file go to \`admin\` => \`graphql\` => \`.graphql-let-yml\`
- Replace the env variable \`\${NEXT_PUBLIC_GRAPHQL_API_ENDPOINT}\` in schema field manually
- Provide your API url in the schema field.

"schema: \${NEXT_PUBLIC_GRAPHQL_API_ENDPOINT}",
to
"schema: https://localhost:8000/graphql",

- Also change the dev command at \`package.json\`
- Go to \`shop/package.json\` file and change the scripts:

"codegen": "node -r dotenv/config $(yarn bin)/graphql-let",
to
"codegen": "graphql-let",
`}</code></pre>
    <p>{`Below are the directories where you will choose to work for frontend stuffs`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# For Admin GraphQL
cd admin/graphql
# For Admin REST
cd admin/rest
# For Shop GraphQL or REST
cd shop
`}</code></pre>
    <p>{`After choosing your working directory
`}<strong parentName="p">{`Go to specific folder and rename the `}<inlineCode parentName="strong">{`.env.template`}</inlineCode>{` => `}<inlineCode parentName="strong">{`.env`}</inlineCode>{` and put your api endpoint here. You will find `}<inlineCode parentName="strong">{`.env.template`}</inlineCode>{` file at the root of your `}<inlineCode parentName="strong">{`admin/{chosen-directory-name}`}</inlineCode>{` or `}<inlineCode parentName="strong">{`shop`}</inlineCode></strong></p>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`Run yarn at the root directory.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# on pickbazar/root directory
yarn
`}</code></pre>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">
        <h3 parentName="li" {...{
          "id": "scripts-to-run-the-fronted-app"
        }}>{`Scripts To Run the fronted App`}</h3>
      </li>
    </ol>
    <h4 {...{
      "id": "for-admin-"
    }}>{`For Admin :`}</h4>
    <p>{`For starting the admin dashboard part with corresponding api data run below commands.`}</p>
    <ul>
      <li parentName="ul">{`using workspace (At the root of the pickbazar directory, you can run the below commands)`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# for dev mode run below command
# GraphQL
yarn dev:admin-gql

# REST
yarn dev:admin-rest
`}</code></pre>
    <p><img alt="frontend script" src={require("../../images/frontend-script.png")} /></p>
    <ul>
      <li parentName="ul">{`without workspace(if you want to run the command within specific project root of `}<inlineCode parentName="li">{`admin/{chosen-directory-name}`}</inlineCode>{`)`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# for dev mode run below command
# GraphQL
yarn dev

# REST
yarn dev
`}</code></pre>
    <p>{`This command will run the app in development mode. Open the suggested url in your terminal. like => http://localhost:3000 .`}</p>
    <p><strong parentName="p">{` Note: `}</strong></p>
    <ul>
      <li parentName="ul">{`The page will automatically reload if you make changes to the code. You will see the build errors and lint warnings in the console.`}</li>
      <li parentName="ul">{`If you saw any error while running make Sure you setup your API endpoint properly at `}<inlineCode parentName="li">{`.env`}</inlineCode>{` file.`}</li>
    </ul>
    <h4 {...{
      "id": "for-shop-"
    }}>{`For Shop :`}</h4>
    <h4 {...{
      "id": "shop-config"
    }}>{`Shop config`}</h4>
    <p>{`From `}<inlineCode parentName="p">{`v4.0.0`}</inlineCode>{`, we changed the structure of the `}<inlineCode parentName="p">{`shop`}</inlineCode>{` directory. So if you're using `}<inlineCode parentName="p">{`v4.0.0`}</inlineCode>{` or later, then you've to do a little bit of customization of the `}<inlineCode parentName="p">{`shop`}</inlineCode>{` directory.`}</p>
    <p>{`At first open `}<inlineCode parentName="p">{`pickbazar -> shop`}</inlineCode>{`,`}</p>
    <ul>
      <li parentName="ul">{`For `}<inlineCode parentName="li">{`REST`}</inlineCode>{`, copy `}<inlineCode parentName="li">{`tsconfig.rest.json`}</inlineCode>{` content to `}<inlineCode parentName="li">{`tsconfig.json`}</inlineCode>{`
or`}</li>
      <li parentName="ul">{`For `}<inlineCode parentName="li">{`GraphQL`}</inlineCode>{` copy `}<inlineCode parentName="li">{`tsconfig.graphql.json`}</inlineCode>{` content to `}<inlineCode parentName="li">{`tsconfig.json`}</inlineCode></li>
    </ul>
    <p>{`Then open `}<inlineCode parentName="p">{`pickbazar -> shop -> .env`}</inlineCode>{` and change `}<inlineCode parentName="p">{`FRAMEWORK_PROVIDER`}</inlineCode>{` to `}<inlineCode parentName="p">{`rest`}</inlineCode>{` for REST installation or `}<inlineCode parentName="p">{`graphql`}</inlineCode>{` for Graphql Installation.`}</p>
    <p>{`Then to starting the shop part with corresponding api run below commands.`}</p>
    <ul>
      <li parentName="ul">{`using workspace (At the root of the pickbazar directory, you can run the below commands)`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# for dev mode run below command
# GraphQL
yarn dev:shop-gql

# REST
yarn dev:shop-rest
`}</code></pre>
    <p><img alt="shop script" src={require("../../images/shop-script.png")} /></p>
    <ul>
      <li parentName="ul">{`without workspace(if you want to run the command within specific project root of `}<inlineCode parentName="li">{`shop`}</inlineCode>{`)`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# for dev mode run below command
# GraphQL
yarn dev

# REST
yarn dev
`}</code></pre>
    <p><strong parentName="p">{` If you want to test your production build admin or shop in local environment then run the below commands. `}</strong></p>
    <h4 {...{
      "id": "admin-at-the-root-of-the-pickbazar-directory-you-can-run-the-below-commands"
    }}>{`Admin (At the root of the pickbazar directory, you can run the below commands)`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# build admin for production
yarn build:admin-gql

#start admin in production mode
yarn start:admin-gql
`}</code></pre>
    <h4 {...{
      "id": "shop-at-the-root-of-the-pickbazar-directory-you-can-run-the-below-commands"
    }}>{`Shop (At the root of the pickbazar directory, you can run the below commands)`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# build shop for production
yarn build:shop-gql

# start shop in production mode
yarn start:shop-gql
`}</code></pre>
    <p><img alt="build1" src={require("../../images/build-1.png")} />{`
`}<img alt="build2" src={require("../../images/build-2.png")} />{`
`}<img alt="start" src={require("../../images/start.png")} /></p>
    <p><strong parentName="p">{` Note `}</strong>{`:
Please see `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file for other builtin helper commands.`}</p>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">{`For development purpose we use yarn workspace if you want to use it then see the `}<inlineCode parentName="li">{`package.json`}</inlineCode>{` file at root, for various workspace specific command.`}</li>
    </ol>
    <ul>
      <li parentName="ul">{`if you prefer single template then just copy the required template folder and separate them. you'll find their `}<inlineCode parentName="li">{`package.json`}</inlineCode>{` file within them and follow the command for dev, build, start.`}</li>
    </ul>
    <ol {...{
      "start": 8
    }}>
      <li parentName="ol">{`For further development & customization check our `}<a parentName="li" {...{
          "href": "/customization"
        }}>{`Frontend Customization`}</a>{` guide.`}</li>
    </ol>
    <h2 {...{
      "id": "available-cli-command"
    }}>{`Available CLI command`}</h2>
    <p>{`We provide some CLI command for developer file easy. Please visit this `}<a parentName="p" {...{
        "href": "/api-command"
      }}>{`link`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      